import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'IconUploader',
  props: {
    iconId: {
      default: ''
    },
    previewAction: {
      default: ''
    },
    previewInitShowed: {
      default: false
    }
  },
  data: function data() {
    return {
      previewShowed: false,
      previewImgUrl: ''
    };
  },
  mounted: function mounted() {
    if (this.previewInitShowed) {
      this.previewShowed = true;
      this.previewImgUrl = this.previewAction;
    }
  },
  methods: {
    bundleFilePreview: function bundleFilePreview(e) {
      var files = e.target.files ? e.target.files : [];

      if (!files.length || !window.FileReader) {
        this.previewShowed = false;
        return;
      }

      var _this = this;

      if (/^image/.test(files[0].type)) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);

        reader.onloadend = function () {
          _this.previewImgUrl = this.result;
          _this.previewShowed = true;

          _this.$emit('onIconSelected', files[0]);
        };
      }
    },
    onDeleteClicked: function onDeleteClicked() {
      this.reset();
      this.$emit('onIconDelete', this.iconId);
    },
    reset: function reset() {
      this.previewImgUrl = '';
      this.previewShowed = false;
    },
    showPreview: function showPreview(url) {
      this.previewImgUrl = url;
      this.previewShowed = true;
    }
  }
};